import { ButtonMode } from '@taxdown/piccolo-web/dist/components/Buttons/Button/types';
import { routes } from 'Constants/routes';

interface QuizQuestion {
  correctAnswer: number;
  totalQuestions: number;
  step: number;
  contextKey: string;
  isBonus: boolean;
  nextRoute: string;
}

interface QuizConfig {
  [key: string]: QuizQuestion;
}

export const QUIZ_CONFIG: QuizConfig = {
  first: {
    correctAnswer: 2,
    totalQuestions: 3,
    isBonus: false,
    contextKey: 'first',
    nextRoute: routes.DATAGATHERING_QUIZ_SECOND_QUESTION,
    step: 1,
  },
  second: {
    correctAnswer: 2,
    totalQuestions: 2,
    isBonus: false,
    contextKey: 'second',
    nextRoute: routes.DATAGATHERING_QUIZ_THIRD_QUESTION,
    step: 2,
  },
  third: {
    correctAnswer: 3,
    totalQuestions: 3,
    isBonus: false,
    contextKey: 'third',
    nextRoute: routes.DATAGATHERING_QUIZ_FOUR_QUESTION,
    step: 3,
  },
  four: {
    correctAnswer: 1,
    totalQuestions: 3,
    isBonus: false,
    contextKey: 'four',
    nextRoute: routes.DATAGATHERING_QUIZ_FIVE_QUESTION,
    step: 4,
  },
  five: {
    correctAnswer: 3,
    totalQuestions: 3,
    isBonus: false,
    contextKey: 'five',
    nextRoute: routes.DATAGATHERING_QUIZ_SIX_QUESTION,
    step: 5,
  },
  six: {
    correctAnswer: 2,
    totalQuestions: 3,
    isBonus: true,
    contextKey: 'six',
    nextRoute: routes.DATAGATHERING_QUIZ_RESULT,
    step: 6,
  },
};

export const getButtonMode = (
  index: number,
  hasAnswered: boolean,
  correctAnswer: number,
  option?: number
): keyof typeof ButtonMode => {
  if (!hasAnswered) return 'secondary';
  const optionNumber = index;
  if (optionNumber === correctAnswer) {
    return 'success';
  }
  if (optionNumber === option && optionNumber !== correctAnswer) {
    return 'error';
  }
  return 'secondary';
};
